import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8670c780"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "font-inter categories pb-10 mb-10 lg:py-6 enter-content-animation px-4 md:px-0",
  style: {"min-height":"40rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "font-bold text-2xl sm:text-3xl pb-2"
}
const _hoisted_3 = {
  key: 1,
  class: "font-bold my-2 bg-slate-200 w-full"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-0" }, "skeleton skel", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-12 pt-5 gap-4 animate-pulse categories__skeletons"
}
const _hoisted_7 = {
  key: 1,
  class: "grid grid-cols-12 pt-5 gap-4 categories__list"
}
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black opacity-10 rounded-xl" }, null, -1))
const _hoisted_11 = { class: "absolute top-3 left-3 text-white" }
const _hoisted_12 = { class: "text-md font-medium" }
const _hoisted_13 = {
  key: 2,
  class: "flex flex-col justify-center items-center sm:pt-14 sm:mt-14 m-auto",
  style: {"padding-bottom":"13.95rem"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "120",
  height: "70",
  viewBox: "0 0 22 22",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 8.78516H6C8 8.78516 9 7.78516 9 5.78516V3.78516C9 1.78516 8 0.785156 6 0.785156H4C2 0.785156 1 1.78516 1 3.78516V5.78516C1 7.78516 2 8.78516 4 8.78516ZM16 8.78516H18C20 8.78516 21 7.78516 21 5.78516V3.78516C21 1.78516 20 0.785156 18 0.785156H16C14 0.785156 13 1.78516 13 3.78516V5.78516C13 7.78516 14 8.78516 16 8.78516ZM16 20.7852H18C20 20.7852 21 19.7852 21 17.7852V15.7852C21 13.7852 20 12.7852 18 12.7852H16C14 12.7852 13 13.7852 13 15.7852V17.7852C13 19.7852 14 20.7852 16 20.7852ZM4 20.7852H6C8 20.7852 9 19.7852 9 17.7852V15.7852C9 13.7852 8 12.7852 6 12.7852H4C2 12.7852 1 13.7852 1 15.7852V17.7852C1 19.7852 2 20.7852 4 20.7852Z",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    fill: "#D5D5D5"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-medium text-lg pt-2" }, "Nenhuma Categoria disponível", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-center" }, "Volte mais tarde", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]

import { useCategory } from '@/composables/useCategory'
    import { useProduct } from '@/composables/useProduct'
    import {onMounted} from 'vue'
    import { categories, apiBaseUrl, restaurant } from '@/global/state/GlobalState';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesIndex',
  setup(__props) {

    // import axiosClient from '@/api/axios';
    onMounted(() => {
        if(!categories.value){
            const { listCategories, categories: categoryList } = useCategory()
            const { listProducts, products: productList } = useProduct()
            
            Promise.all([
                listCategories(1, { perPage: 100 }),
                listProducts(1, { perPage: 100 })
            ]).then(() => {
                categories.value = categoryList.value.map(c => ({
                    ...c,
                    products: productList.value.filter(p => p.categoryId === c.id)
                }))
            })
        } 
    })

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(restaurant)?.id)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_unref(restaurant)?.restaurantConfig?.menuTitle ?? 'Menu'), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5)),
    _createElementVNode("div", null, [
      (!_unref(categories)?.length && !_unref(restaurant)?.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6,7,8], (i, index) => {
              return _createElementVNode("div", {
                key: index,
                class: "relative col-span-6 md:col-span-4 lg:col-span-3 bg-slate-200 rounded-xl h-40 w-full sm:h-60 categories__skeletons--skeleton"
              })
            }), 64))
          ]))
        : _createCommentVNode("", true),
      (_unref(categories)?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category, index) => {
              return (_openBlock(), _createBlock(_component_RouterLink, {
                to: {name:'categories.show', params: { id: category.id }},
                key: index,
                class: "relative col-span-6 md:col-span-4 lg:col-span-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      class: "rounded-xl w-full sm:h-60 object-cover opacity-90",
                      src: category.banner ? `${_unref(apiBaseUrl)}/storage/${category.banner}` : '/assets/no-image.png',
                      onError: _cache[0] || (_cache[0] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                    }, null, 40, _hoisted_9),
                    _hoisted_10
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h2", _hoisted_12, _toDisplayString(category.name), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_unref(categories)?.length && _unref(restaurant)?.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_17))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})